import {connect} from 'react-redux';
import {get} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {pageSize} from '/constant/data.constant';
import {
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
} from '/enum/apiFields.enum';
import {getOrders} from '/redux/action/client.action';
import {
  ordersById,
  ordersIsLoadingStateValue,
  ordersMeta,
  ordersPaginationParamsById,
  ordersSortParams,
} from '/redux/selector/client.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import OrderHistoryList from './OrderHistoryList';

export default connect(
  createStructuredSelector({
    ordersIsLoading: ordersIsLoadingStateValue,
    orders: ordersById,
    meta: ordersMeta,
    featureFlag: variablesFeatureFlag,
    ordersSorts: ordersSortParams,
    ordersParams: ordersPaginationParamsById,
  }),
  dispatch => ({
    getOrders: ({clientId, orderParams, appendData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getOrders({clientId, orderParams, appendData})),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    fetchInitialOrders: () => {
      const {ordersSorts = {}, meta: {sortParams} = {}} = stateProps;
      const {clientId} = ownProps;
      const activeSorts = sortParams || ordersSorts;

      return dispatchProps.getOrders({
        clientId,
        orderParams: {
          ...activeSorts,
          [PAGE_NUMBER_FIELD_NAME]: 1,
          [PAGE_SIZE_FIELD_NAME]: pageSize,
        },
        appendData: false,
      });
    },
    sortOrders: ({sortParam}: any) => {
      const {clientId} = ownProps;
      return dispatchProps.getOrders({
        clientId,
        orderParams: {
          ...get(sortParam, 'params', {}),
          [PAGE_NUMBER_FIELD_NAME]: 1,
          [PAGE_SIZE_FIELD_NAME]: pageSize,
        },
        appendData: false,
      });
    },
    // @ts-expect-error TS(7030): Not all code paths return a value.
    fetchMoreOrders: () => {
      const {
        ordersIsLoading,
        ordersSorts = {},
        ordersParams = {},
        meta: {isEndReached, sortParams} = {},
      } = stateProps;

      const {clientId} = ownProps;
      const activeSorts = sortParams || ordersSorts;

      if (!ordersIsLoading && !isEndReached) {
        return dispatchProps.getOrders({
          clientId,
          orderParams: {
            ...activeSorts,
            ...ordersParams,
          },
          appendData: true,
        });
      }
    },
  }),
)(OrderHistoryList);
